import React, { Component, Fragment } from 'react';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { Container, Grid, Menu, MenuMenu, Icon, Divider, Loader, Segment } from 'semantic-ui-react';
import Configuration from '../config/Configuration.js';
import ProviderDashboard from '../components/ProviderDashboard';
import ServiceDashboard from './ServiceDashboard';
import Questionnaire from '../components/Questionnaire';
import Patient from '../components/Patient';
import Services from '../components/Services';
import Profile from '../components/Profile';
import CitizenProfile from '../components/citizen/CitizenProfile';
import CitizenServices from '../components/citizen/CitizenServices';
import CitizenQuestionnaire from '../components/citizen/CitizenQuestionnaire';
import Chatbot from '../components/chatbot/Chatbot';
import Organisation from '../components/Organisation';
import ServiceRequest from '../components/ServiceRequest';
import Contact from '../components/Contact';
import Faq from '../components/Faq';
import { authHeader } from '../helpers/auth-header.js';
import ErrorBoundary from '../components/ErrorBoundary';
import RegisterPatientForm from './RegisterPatientForm';
import ChooseReferralType from './ChooseReferralType';
import DirectReferral from './DirectReferral';
import NeedsBasedReferral from './NeedsBasedReferral';
import ZoneDashboard from './ZoneDashboard';
import ReferralOverview from './ReferralOverview';
import UserOverview from './UserOverview';
import { withTranslation } from 'react-i18next';
import { createMedia } from "@artsy/fresnel";
import AppLayout from '../components/citizen/CitizenLayout';
import CitizenSidebar from '../components/citizen/CitizenSidebar';

const AppMedia = createMedia({
    breakpoints: {
        mobile: 320,
        tablet: 768,
        computer: 992,
        largeScreen: 1200,
        widescreen: 1920
    }
});

const { Media, MediaContextProvider } = AppMedia;

class HealthMatchBody extends Component {

    constructor(props) {
        super(props);
        this.config = new Configuration();
        this.state = {
            activeItem: 'patients',
            organizationType: '',
            serviceRequestStatus: '',
            onlyMyCases: false,
            onlyHouseVisits: false,
            onlyFirstFollowUp: false,
            onlySecondFollowUp: false,
            onlyHighRiskContacts: false,
            onlyForeignSpeakers: false,
            onlyVulnerablePeople: false,
            onlyWithPhoneNumber: false,
            onlyClosureNeeded: false,
            activePage: 1,
            postalCode: null
        }
    }

    handleError = (error) => {
        console.log(error.message);
    }

    logout = () => {
        this.props.logout();
    }

    setServiceRequestStatus = (status) => {
        this.setState({ serviceRequestStatus: status });
    }

    toggleOnlyMyCases = () => {
        this.setState({
            onlyMyCases: !this.state.onlyMyCases
        });
    }

    toggleOnlyHouseVisits = () => {
        this.setState({
            onlyHouseVisits: !this.state.onlyHouseVisits,
            onlyFirstFollowUp: false,
            onlySecondFollowUp: false,
            onlyHighRiskContacts: false,
            onlyForeignSpeakers: false,
            onlyVulnerablePeople: false
        });
    }

    toggleOnlyFirstFollowUp = () => {
        this.setState({
            onlyFirstFollowUp: !this.state.onlyFirstFollowUp,
            onlySecondFollowUp: false,
            onlyHighRiskContacts: false,
            onlyForeignSpeakers: false,
            onlyVulnerablePeople: false,
            onlyHouseVisits: false
        });
    }

    toggleOnlySecondFollowUp = () => {
        this.setState({
            onlySecondFollowUp: !this.state.onlySecondFollowUp,
            onlyHighRiskContacts: false,
            onlyForeignSpeakers: false,
            onlyVulnerablePeople: false,
            onlyHouseVisits: false,
            onlyFirstFollowUp: false
        });
    }

    toggleOnlyHighRiskContacts = () => {
        this.setState({
            onlyHighRiskContacts: !this.state.onlyHighRiskContacts,
            onlyForeignSpeakers: false,
            onlyVulnerablePeople: false,
            onlyHouseVisits: false,
            onlyFirstFollowUp: false,
            onlySecondFollowUp: false
        });
    }

    toggleOnlyForeignSpeakers = () => {
        this.setState({
            onlyForeignSpeakers: !this.state.onlyForeignSpeakers,
            onlyVulnerablePeople: false,
            onlyHouseVisits: false,
            onlyFirstFollowUp: false,
            onlyHighRiskContacts: false
        });
    }

    toggleOnlyVulnerablePeople = () => {
        this.setState({
            onlyVulnerablePeople: !this.state.onlyVulnerablePeople,
            onlyHouseVisits: false,
            onlyFirstFollowUp: false,
            onlyHighRiskContacts: false,
            onlyForeignSpeakers: false
        });
    }

    toggleOnlyWithPhoneNumber = () => {
        this.setState({
            onlyWithPhoneNumber: !this.state.onlyWithPhoneNumber
        });
    }

    toggleOnlyClosureNeeded = () => {
        this.setState({
            onlyClosureNeeded: !this.state.onlyClosureNeeded
        });
    }

    setPostalCode = (postalCode) => {
        this.setState({
            postalCode: postalCode,
        });
    }

    setActivePage = (activePage) => {
        this.setState({
            activePage: activePage,
        });
    }

    handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    handleResponseError(response) {
        return {
            error: true,
            status: response.status
        };
    }

    retrieveOrganization() {
        return fetch(this.config.ORGANIZATIONS_URL + "/" + this.props.activeUser.organization.uuid, {
            method: 'GET',
            headers: authHeader()
        })
            .then(response => {
                if (!response.ok) {
                    this.handleResponseError(response);
                }
                return response.json();
            })
            .then(organization => {
                this.setState({
                    organizationType: organization.type
                });
            })
            .catch(error => {
                this.handleError(error);
            });
    }

    getFullDashboard = () => {
        if (this.props.userType === "patient") {
            return <Fragment>
                <Divider hidden style={{ marginTop: '4em' }} />
                {this.getDashboardMenu()}
            </Fragment>;
        } else {
            return <Fragment>
                <Divider hidden style={{ marginTop: '4em' }} />
                {this.getDashboardMenu()}
                <Grid padded='horizontally' stackable>
                    <Grid.Column width={13}>
                        <ErrorBoundary>
                            {this.getDashboardBody()}
                        </ErrorBoundary>
                    </Grid.Column>
                    <Grid.Column width={3}>
                        {this.getDashboardMenu()}
                    </Grid.Column>
                </Grid>
            </Fragment>;
        }
    }

    getMobileDashboard = () => {
        return <Fragment>
            <Divider hidden style={{ marginTop: '4em' }} />
            <ErrorBoundary>
                {this.getDashboardBody()}
            </ErrorBoundary>
        </Fragment>;
    }

    getDashboard = () => {
        return <MediaContextProvider>
            <Container as={Media} greaterThanOrEqual="computer" fluid>
                {this.getFullDashboard()}
            </Container>
            <Container as={Media} lessThan="computer" fluid>
                {this.getMobileDashboard()}
            </Container>
        </MediaContextProvider>
    }

    componentDidMount() {
        if (this.props.activeUser && this.props.userType === "practitioner") {
            this.retrieveOrganization();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.activeUser && this.props.activeUser) {
            console.log("✅ Trigger retrieveOrganization");
            this.retrieveOrganization();
        }
    }

    getCitizenRoutes = () => {
        const { activeUser } = this.props;

        return (
            <Routes>
                <Route index element={<CitizenProfile activeUser={activeUser} />} />
                <Route path="profile" element={<CitizenProfile activeUser={activeUser} />} />
                <Route path="services" element={<CitizenServices activeUser={activeUser} />} />
                <Route path="chatbot" element={<Chatbot />} />
                <Route path="questionnaire" element={<CitizenQuestionnaire activeUser={activeUser} />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        );
    };

    getReferrerMenu = () => {
        const { t } = this.props;
        const { activeItem } = this.state;
        if (this.props.activeUser) {
            if (this.state.organizationType === "Apotheek") {
                return <Fragment>
                    <Menu.Item>
                        <Menu.Header>{t("Overview")}</Menu.Header>
                        <Menu.Menu>
                            <Menu.Item
                                as={Link}
                                to='/'
                                name='requests'
                                active={activeItem === 'requests'}
                                onClick={this.handleItemClick}
                            ><Icon name='street view' color='blue' />{t("Requests")}</Menu.Item>
                        </Menu.Menu>
                    </Menu.Item>
                </Fragment >
            } else {
                return <Fragment>
                    <Menu.Item>
                        <Menu.Header>{t("Overview")}</Menu.Header>
                        <Menu.Menu>
                            <Menu.Item
                                as={Link}
                                to='/'
                                name='patients'
                                active={activeItem === 'patients'}
                                onClick={this.handleItemClick}
                            ><Icon name='street view' color='blue' />{t("Patients")}</Menu.Item>
                            <Menu.Item
                                as={Link}
                                to='/services'
                                name='services'
                                active={activeItem === 'services'}
                                onClick={this.handleItemClick}
                            ><Icon name='handshake' color='blue' />{t("Services")}</Menu.Item></Menu.Menu>
                    </Menu.Item>
                </Fragment>;
            }
        }
    }

    getFullMenu = () => {
        const { t } = this.props;
        const { activeItem } = this.state;
        return <Fragment>
            <Menu.Item>
                <Menu.Header>{t("Overview")}</Menu.Header>
                <Menu.Menu>
                    <Menu.Item
                        as={Link}
                        to='/'
                        name='requests'
                        active={activeItem === 'requests'}
                        onClick={this.handleItemClick}
                    ><Icon name='street view' color='blue' />{t("Requests")}</Menu.Item>
                    <Menu.Item
                        as={Link}
                        to='/referrals'
                        name='referrals'
                        active={activeItem === 'referrals'}
                        onClick={this.handleItemClick}
                    ><Icon name='mail forward' color='blue' />{t("Referrals")}</Menu.Item>
                    <Menu.Item
                        as={Link}
                        to='/services'
                        name='services'
                        active={activeItem === 'services'}
                        onClick={this.handleItemClick}
                    ><Icon name='handshake' color='blue' />{t("Services")}</Menu.Item>
                </Menu.Menu>
            </Menu.Item>
        </Fragment >
    }

    getServiceMenu = () => {
        const { t } = this.props;
        const { activeItem } = this.state;
        return <Fragment>
            <Menu.Item>
                <Menu.Header>{t("Overview")}</Menu.Header>
                <Menu.Menu>
                    <Menu.Item
                        as={Link}
                        to='/'
                        name='requests'
                        active={activeItem === 'requests'}
                        onClick={this.handleItemClick}
                    ><Icon name='street view' color='blue' />{t("Referrals")}</Menu.Item>
                    <Menu.Item
                        as={Link}
                        to='/services'
                        name='services'
                        active={activeItem === 'services'}
                        onClick={this.handleItemClick}
                    ><Icon name='handshake' color='blue' />{t("Services")}</Menu.Item>
                </Menu.Menu>
            </Menu.Item>
        </Fragment >
    }

    getCommonMenu = () => {
        const { t } = this.props;
        const { activeItem } = this.state;
        return <Fragment>
            <Menu.Item>
                <Menu.Header>{t("Settings")}</Menu.Header>
                <Menu.Menu>
                    <Menu.Item
                        as={Link}
                        to='/profile'
                        name='profile'
                        active={activeItem === 'profile'}
                        onClick={this.handleItemClick}
                    ><Icon name='edit' color='blue' />{t("My Profile")}</Menu.Item>
                    <Menu.Item
                        as={Link}
                        to='/organisation'
                        name='organisation'
                        active={activeItem === 'organisation'}
                        onClick={this.handleItemClick}
                    ><Icon name='hospital' color='blue' />{t("My Organisation")}</Menu.Item>
                </Menu.Menu>
            </Menu.Item>
            <Menu.Item
                as={Link}
                onClick={this.logout}
                name='log out'
                active={activeItem === 'log out'}
            ><Icon name='log out' color='blue' />{t("Log Out")}</Menu.Item>
        </Fragment>
    }

    getZoneMenu = () => {
        const { t } = this.props;
        const { activeItem } = this.state;
        return <Fragment>
            <Menu.Item>
                <Menu.Header>{t("Overview")}</Menu.Header>
                <Menu.Menu>
                    <Menu.Item
                        as={Link}
                        to='/'
                        name='dashboard'
                        active={activeItem === 'dashboard'}
                        onClick={this.handleItemClick}
                    ><Icon name='dashboard' color='blue' />{t("Dashboard")}</Menu.Item>
                    <Menu.Item
                        as={Link}
                        to='/referraloverview'
                        name='referraloverview'
                        active={activeItem === 'referraloverview'}
                        onClick={this.handleItemClick}
                    ><Icon name='mail forward' color='blue' />{t("Verwijsoverzicht")}</Menu.Item>
                    <Menu.Item
                        as={Link}
                        to='/users'
                        name='users'
                        active={activeItem === 'users'}
                        onClick={this.handleItemClick}
                    ><Icon name='users' color='blue' />{t("Gebruikers")}</Menu.Item>
                    <Menu.Item
                        as={Link}
                        to='/services'
                        name='services'
                        active={activeItem === 'services'}
                        onClick={this.handleItemClick}
                    ><Icon name='handshake' color='blue' />{t("Services")}</Menu.Item>
                </Menu.Menu>
            </Menu.Item>
        </Fragment >
    }

    getDashboardMenu = () => {
        console.log("HealthMatchBody props/state:", {
            userType: this.props.userType,
            activeUser: this.props.activeUser,
            organizationType: this.state.organizationType
        });
        console.log("Rendering menu for userType:", this.props.userType);
        if (this.props.activeUser) {
            if (this.props.userType === "patient") {
                const { t } = this.props;
                return (
                    <Fragment>
                        <AppLayout
                            topOffsetPx={56} // stem af op je topbar-hoogte
                            sidebar={({ collapsed, setCollapsed }) => (
                                <CitizenSidebar
                                    t={t}
                                    activeItem={this.state.activeItem}
                                    onItemClick={this.handleItemClick}
                                    logout={this.logout}
                                    collapsed={collapsed}
                                    setCollapsed={setCollapsed}
                                />
                            )}
                        >
                            <Segment basic>
                                <ErrorBoundary>
                                    {this.getCitizenRoutes()}
                                </ErrorBoundary>
                            </Segment>
                        </AppLayout>
                    </Fragment>
                );
            } else {
                if (this.state.organizationType.includes(this.config.HYBRID_ORGANISATION)) {
                    return <Container>
                        <Menu vertical fluid size='large'>
                            {this.getFullMenu()}
                            {this.getCommonMenu()}
                        </Menu>
                    </Container>;
                } else {
                    if (this.props.activeUser.isObserver) {
                        return <Container>
                            <Menu vertical fluid size='large'>
                                {this.getServiceMenu()}
                                {this.getCommonMenu()}
                            </Menu>
                        </Container>;
                    } else {
                        if (this.state.organizationType === "ELZ") {
                            return <Container>
                                <Menu vertical fluid size='large'>
                                    {this.getZoneMenu()}
                                    {this.getCommonMenu()}
                                </Menu>
                            </Container>;
                        } else {
                            return <Container>
                                <Menu vertical fluid size='large'>
                                    {this.getReferrerMenu()}
                                    {this.getCommonMenu()}
                                </Menu>
                            </Container>;
                        }
                    }
                }
            }
        } else {
            return null;
        }
    }

    getDashboardBody = () => {
        if (this.props.activeUser) {
            if (this.props.userType === "patient") {
                return <Routes>
                    <Route path='/' element={<CitizenProfile activeUser={this.props.activeUser} />} />
                    <Route path='/profile' element={<CitizenProfile activeUser={this.props.activeUser} />} />
                    <Route path='/services' element={<CitizenServices activeUser={this.props.activeUser} />} />
                    <Route path="/questionnaire" element={<CitizenQuestionnaire activeUser={this.props.activeUser} />} />
                </Routes>;
            } else {
                if (this.props.activeUser.isObserver) {
                    return <Routes>
                        <Route path='/' element={<ServiceDashboard activeUser={this.props.activeUser} />} />
                        <Route path='/referrals' element={<ProviderDashboard activeUser={this.props.activeUser} />} />
                        <Route path='/servicerequest' element={<ServiceRequest activeUser={this.props.activeUser} />} />
                        <Route path='/patient' element={<Patient activeUser={this.props.activeUser} />} />
                        <Route path='/profile' element={<Profile activeUser={this.props.activeUser} />} />
                        <Route path='/organisation' element={<Organisation activeUser={this.props.activeUser} />} />
                        <Route path='/services' element={<Services activeUser={this.props.activeUser} />} />
                        <Route path='/contact' element={<Contact />} />
                        <Route path='/faq' element={<Faq />} />
                        <Route path='/newcontact' element={<RegisterPatientForm />} />
                        <Route path='/choosereferral' element={<ChooseReferralType />} />
                        <Route path="/questionnaire" element={<Questionnaire organizationType={this.state.organizationType} activeUser={this.props.activeUser} />} />
                        <Route path='/directreferral' element={<DirectReferral activeUser={this.props.activeUser} />} />
                        <Route path='/needsbasedreferral' element={<NeedsBasedReferral activeUser={this.props.activeUser} />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>;
                } else {
                    if (this.state.organizationType === "ELZ") {
                        return <Routes>
                            <Route path='/' element={<ZoneDashboard activeUser={this.props.activeUser} />} />
                            <Route path='/referraloverview' element={<ReferralOverview />} />
                            <Route path='/users' element={<UserOverview />} activeUser={this.props.activeUser} />
                            <Route path='/services' element={<Services activeUser={this.props.activeUser} />} />
                            <Route path='/profile' element={<Profile activeUser={this.props.activeUser} />} />
                            <Route path='/organisation' element={<Organisation activeUser={this.props.activeUser} />} />
                            <Route path="*" element={<Navigate to="/" />} />
                        </Routes>;
                    } else {
                        return <Routes>
                            <Route path='/' element={<ProviderDashboard activeUser={this.props.activeUser} />} />
                            <Route path='/profile' element={<Profile activeUser={this.props.activeUser} />} />
                            <Route path='/organisation' element={<Organisation activeUser={this.props.activeUser} />} />
                            <Route path='/patient' element={<Patient activeUser={this.props.activeUser} />} />
                            <Route path='/services' element={<Services activeUser={this.props.activeUser} />} />
                            <Route path='/contact' element={<Contact />} />
                            <Route path='/faq' element={<Faq />} />
                            <Route path='/newcontact' element={<RegisterPatientForm />} />
                            <Route path='/choosereferral' element={<ChooseReferralType />} />
                            <Route path="/questionnaire" element={<Questionnaire organizationType={this.state.organizationType} activeUser={this.props.activeUser} />} />
                            <Route path='/directreferral' element={<DirectReferral activeUser={this.props.activeUser} />} />
                            <Route path='/needsbasedreferral' element={<NeedsBasedReferral activeUser={this.props.activeUser} />} />
                            <Route path="*" element={<Navigate to="/" />} />
                        </Routes>;
                    }
                }
            }
        } else {
            return null;
        }
    }

    render() {
        if (!this.props.activeUser) {
            return <Loader />;
        }
        return this.getDashboard();
    }
}

export default withTranslation()(HealthMatchBody);
